import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box } from "rizzui/box";
import { Button } from "rizzui/button";
import { Text, Title } from "rizzui/typography";
import { useModal } from "../hooks/useModal";
import SingleEntry from "./singleEntry";
import ImportFile from "./cards/importFile";
import cn from "../lib/utils/class-name";

export default function EmptyState({
  heading,
  subHeading,
  button = "Create campaign",
  link = "",
  page = "",
}: {
  heading: string;
  subHeading: string;
  button?: string;
  link?: string;
  page?: string;
}) {
  const navigate = useNavigate();
  const { openModal } = useModal();
  return (
    <div className="w-[310px] h-[162px]">
      <Box className="">
        <Title className="mb-[15px] text-primary-dark font-ibmPlexSerif font-[600] text-[18px] leading-[23.4px]">
          {heading}
        </Title>
        <Text
          className={cn(
            "font-[400] text-[#758599] font-gilroy text-[14px] leading-[16.8px]",
            page === "leads" ? "w-[184px]" : "w-fit"
          )}
        >
          {subHeading}
        </Text>
        <Box className="flex flex-row mt-[38px] gap-[16px]">
          <Button
            onClick={() =>
              page === "leads"
                ? openModal({ view: <ImportFile page="leads" type="csv" /> })
                : navigate("/campaigns/new")
            }
            variant="text"
            className="font-[500] leading-[15.84] text-foreground hover:text-foreground font-switzer text-[12px] bg-btn"
          >
            {button}
          </Button>
          {page !== "leads" && (
            <Link
              to={"/campaigns/new"}
              className="font-[400] font-gilroy text-[14px] leading-[16.98x] place-self-center text-btn"
            >
              {link}
            </Link>
          )}
          {page === "leads" && (
            <Text
              onClick={() => openModal({ view: <SingleEntry /> })}
              className="font-[400] font-gilroy text-[14px] cursor-pointer leading-[16.98x] place-self-center text-btn"
            >
              {link}
            </Text>
          )}
        </Box>
      </Box>
    </div>
  );
}
